import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('FormError', null, { withChildren: true });
